import { SHOPPING_ADD_ON_CATEGORY } from './constants';

export const REPLICATED_SERVER_URL = process.env.NEXT_PUBLIC_SERVER_ENDPOINT;
export const BACKOFFICE_SERVER_URL = process.env.NEXT_PUBLIC_BACKOFFICE_SERVER_ENDPOINT;

export const REPLICATED_AUTH_REFRESH_URL = process.env.NEXT_PUBLIC_LEGACY_REAUTH_ENDPOINT;
export const BACKOFFICE_AUTH_REFRESH_URL = process.env.NEXT_PUBLIC_LEGACY_BACKOFFICE_REAUTH_ENDPOINT;

export const REPLICATED_AUTH_URL = process.env.NEXT_PUBLIC_LEGACY_AUTH_ENDPOINT;
export const BACKOFFICE_AUTH_URL = process.env.NEXT_PUBLIC_LEGACY_BACKOFFICE_AUTH_ENDPOINT;

const CURRENT_SERVER_URL =
  typeof globalThis.window !== undefined
    ? globalThis.window?.location?.origin?.includes('backoffice')
      ? BACKOFFICE_SERVER_URL
      : REPLICATED_SERVER_URL
    : globalThis.globalThisCustom?.isBackOffice
    ? BACKOFFICE_SERVER_URL
    : REPLICATED_SERVER_URL;

const CURRENT_AUTH_REFRESH_URL =
  typeof globalThis.window !== undefined
    ? globalThis.window?.location?.origin?.includes('backoffice')
      ? BACKOFFICE_AUTH_REFRESH_URL
      : REPLICATED_AUTH_REFRESH_URL
    : globalThis.globalThisCustom?.isBackOffice
    ? BACKOFFICE_AUTH_REFRESH_URL
    : REPLICATED_AUTH_REFRESH_URL;

const CURRENT_AUTH_URL =
  typeof globalThis.window !== undefined
    ? globalThis.window?.location?.origin?.includes('backoffice')
      ? BACKOFFICE_AUTH_URL
      : REPLICATED_AUTH_URL
    : globalThis.globalThisCustom?.isBackOffice
    ? BACKOFFICE_AUTH_URL
    : REPLICATED_AUTH_URL;

export const SERVER_URL = CURRENT_SERVER_URL;
export const AUTH_URL = CURRENT_AUTH_URL;
export const AUTH_REFRESH_URL = CURRENT_AUTH_REFRESH_URL;
export const STRAPI_SERVER_URL = process.env.NEXT_PUBLIC_STRAPI_SERVER_ENDPOINT || '';

export const TOKENEX_VARS = {
  SERVER_URL: process.env.NEXT_PUBLIC_TOKENEX_SERVER_URL,
  SCHEME: process.env.NEXT_PUBLIC_TOKENEX_SCHEME,
  API: process.env.NEXT_PUBLIC_TOKENEX_API,
  ID: process.env.NEXT_PUBLIC_TOKENEX_ID,
};

export const KLAVIYO_KEY = process.env.NEXT_PUBLIC_KLAVIYO_KEY;

export const ZENDESK_KEY = process.env.NEXT_PUBLIC_ZENDESK_KEY;
export const FULLSTORY_ORG = process.env.NEXT_PUBLIC_FULLSTORY_ORG;
export const ORIGIN_URL = process.env.NEXT_PUBLIC_ORIGIN_URL;
export const HOST = process.env.NEXT_PUBLIC_HOST;

export const SHOPPING_ADD_ON = SHOPPING_ADD_ON_CATEGORY;
export const IS_PROD = process.env.NEXT_PUBLIC_ENV === 'production';
export const IS_STAGE = process.env.NEXT_PUBLIC_ENV === 'staging';
export const IS_DEV = process.env.NEXT_PUBLIC_ENV === 'dev';
export const IS_LOCAL = process.env.NEXT_PUBLIC_ENV === 'local';
export const NEXT_MEDIA_PATH = IS_PROD
  ? 'https://pawtree.com/'
  : IS_STAGE
  ? 'https://v2-stg.pawtree.com/'
  : 'https://v2.pawtreedev.com/';
export const TOAST_AUTOCLOSE_TIME = 5000;

export const FALLBACK_REPLICATED_HOST = process.env.NEXT_PUBLIC_FALLBACK_REPLICATED_HOST || '';
export const FALLBACK_BACKOFFICE_HOST = process.env.NEXT_PUBLIC_FALLBACK_BACKOFFICE_HOST || '';
export const NEXT_PUBLIC_RUN_MODE = process.env.NEXT_PUBLIC_RUN_MODE;

export const IS_LOCAL_MODE = NEXT_PUBLIC_RUN_MODE === 'local';
export const IS_LOCAL_INTEGRATED_MODE = NEXT_PUBLIC_RUN_MODE === 'integrated';
export const IS_LOCAL_DOCKERIZED_MODE = NEXT_PUBLIC_RUN_MODE === 'dockerized';

export const NEXT_PUBLIC_DOCKER_ORIGIN_FOR_SERVER_SIDE_CALLS =
  process.env.NEXT_PUBLIC_DOCKER_ORIGIN_FOR_SERVER_SIDE_CALLS || '';

export const PREVENT_ROBOTS_FROM_INDEXING = IS_DEV || IS_STAGE;
export const NEXT_PUBLIC_PRODUCT_IMAGE_BASE_URL = `/api/product-image`;
export const ALGOLIA_APPLICATION_ID = (process.env.ALGOLIA_APP_ID || process.env.NEXT_PUBLIC_ALGOLIA_APP_ID)!;
export const ALGOLIA_API_KEY = (process.env.ALGOLIA_API_KEY || process.env.NEXT_PUBLIC_ALGOLIA_API_KEY)!;
export const ALGOLIA_INDEX_NAME = process.env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME!;
export const ALGOLIA_QUERY_SUGGESTIONS_INDEX_NAME =
  process.env.NEXT_PUBLIC_ALGOLIA_QUERY_SUGGESTIONS_INDEX_NAME! || `${ALGOLIA_INDEX_NAME}_query_suggestions`;
export const ALGOLIA_ANALYTICS_KEY = (process.env.NEXT_PUBLIC_ALGOLIA_ANALYTICS_KEY || ALGOLIA_API_KEY)!;
export const ALGOLIA_RECOMMEND_KEY = (process.env.NEXT_PUBLIC_ALGOLIA_RECOMMEND_KEY || ALGOLIA_API_KEY)!;

export const GOOGLE_CLIENT_ID = process.env.NEXT_PUBLIC_GOOGLE_API_KEY || '';
export const FACEBOOK_API_KEY = process.env.NEXT_PUBLIC_FACEBOOK_API_KEY || '';
export const APPLE_CLIENT_ID = process.env.NEXT_PUBLIC_APPLE_CLIENT_ID || 'com.pawtree';
export const APPLE_API_KEY = process.env.NEXT_PUBLIC_APPLE_API_KEY || '';
export const APPLE_TEAM_ID = process.env.NEXT_PUBLIC_APPLE_TEAM_ID || '';
export const APPLE_REDIRECT_URL = process.env.NEXT_PUBLIC_APPLE_REDIRECT_URL || '';
export const RECAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || '';
